
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire8a08"];
var parcelRegister = parcelRequire.register;
parcelRegister("gJOeO", function(module, exports) {

$parcel$export(module.exports, "LoginPage", function () { return $c2f7d181abd7de77$export$f14c0e3f98d164c0; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $jCoLF = parcelRequire("jCoLF");

var $60T1K = parcelRequire("60T1K");

var $l5tbi = parcelRequire("l5tbi");

var $h6oqG = parcelRequire("h6oqG");

var $3ta5H = parcelRequire("3ta5H");

var $PW6XX = parcelRequire("PW6XX");
const $c2f7d181abd7de77$var$Container = (0, $jCoLF.default)((0, $60T1K.LinearGradientBackground)).withConfig({
    displayName: "LoginPage__Container",
    componentId: "sc-n03cmw-0"
})([
    "display:flex;align-items:center;justify-content:center;"
]);
const $c2f7d181abd7de77$export$f14c0e3f98d164c0 = ()=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)($c2f7d181abd7de77$var$Container, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $h6oqG.ComponentFabric), {
            flavors: {
                [(0, $PW6XX.AvailableApplicationFlavors).DEFAULT]: /*#__PURE__*/ (0, $ih19M.jsx)((0, $l5tbi.Login), {}),
                [(0, $PW6XX.AvailableApplicationFlavors).TELEMED]: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3ta5H.default).Auth, {}),
                [(0, $PW6XX.AvailableApplicationFlavors).SUNRISE]: /*#__PURE__*/ (0, $ih19M.jsx)((0, $l5tbi.Login), {}),
                [(0, $PW6XX.AvailableApplicationFlavors).CEG]: /*#__PURE__*/ (0, $ih19M.jsx)((0, $l5tbi.Login), {})
            }
        })
    });
};

});
parcelRegister("60T1K", function(module, exports) {

$parcel$export(module.exports, "LinearGradientBackground", function () { return $460d6d69e19755a2$export$2c8c0cad3b6e9ec6; });

var $jCoLF = parcelRequire("jCoLF");
const $460d6d69e19755a2$export$2c8c0cad3b6e9ec6 = (0, $jCoLF.default).div.withConfig({
    displayName: "LinearGradientBackground",
    componentId: "sc-1v12nhp-0"
})([
    "width:100%;min-height:calc((var(--vhw,1vh) * 100));background-image:linear-gradient(340deg,#fff5f1,#f4dfe2);"
]);

});

parcelRegister("l5tbi", function(module, exports) {

$parcel$export(module.exports, "Login", function () { return $f5a0b35dc85e9d3d$export$21a94553ffa41578; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $jCoLF = parcelRequire("jCoLF");

var $5koK7 = parcelRequire("5koK7");

var $9CbxY = parcelRequire("9CbxY");

var $2ZkYi = parcelRequire("2ZkYi");

var $jEiCU = parcelRequire("jEiCU");

var $iSaFr = parcelRequire("iSaFr");

var $iOlMk = parcelRequire("iOlMk");

var $6rqzN = parcelRequire("6rqzN");

var $dsDBD = parcelRequire("dsDBD");
parcelRequire("PW6XX");
const $f5a0b35dc85e9d3d$var$Container = (0, $jCoLF.default)((0, $iSaFr.RoundedRectangleWithShadow)).withConfig({
    displayName: "Login__Container",
    componentId: "sc-2wwjqu-0"
})([
    "width:610px;padding:63px 0 101px;display:flex;flex-direction:column;align-items:center;@media screen and (max-width:768px){width:calc(100% - 24px);box-sizing:border-box;}"
]);
const $f5a0b35dc85e9d3d$var$Form = (0, $jCoLF.default).form.withConfig({
    displayName: "Login__Form",
    componentId: "sc-2wwjqu-1"
})([
    "margin-top:43px;width:398px;display:flex;flex-direction:column;align-items:center;",
    "{margin-bottom:13px;}",
    ":last-of-type{margin-bottom:32px;}@media screen and (max-width:475px){width:calc(100% - 24px);}"
], (0, $9CbxY.InputWithIconContainer), (0, $9CbxY.InputWithIconContainer));
const $f5a0b35dc85e9d3d$var$ButtonContainer = (0, $jCoLF.default)((0, $5koK7.PrimaryButtonContainer)).withConfig({
    displayName: "Login__ButtonContainer",
    componentId: "sc-2wwjqu-2"
})([
    "width:244px;"
]);
const $f5a0b35dc85e9d3d$var$onSubmit = async (username, password, onError)=>{
    try {
        const result = await (0, $dsDBD.default).postObtainToken({
            username: username,
            password: password
        });
        (0, $iOlMk.setToken)(result.token);
        (0, $iOlMk.setRefreshToken)(result.refresh);
    } catch (e) {
        console.log(e);
        onError();
    }
};
const $f5a0b35dc85e9d3d$export$21a94553ffa41578 = (props)=>{
    const [login, setLogin] = (0, $bh6RR.useState)("");
    const [password, setPassword] = (0, $bh6RR.useState)("");
    const [isError, setError] = (0, $bh6RR.useState)(false);
    // useLayoutEffect(() => {
    //   if (window.ReactNativeWebView) {
    //     window.ReactNativeWebView.postMessage("logout");
    //   }
    // }, []);
    (0, $bh6RR.useEffect)(()=>{
        setError(false);
    }, [
        login,
        password
    ]);
    const handleSubmit = (event)=>{
        var _props$onSubmit;
        event.preventDefault();
        $f5a0b35dc85e9d3d$var$onSubmit(login, password, ()=>setError(true));
        (_props$onSubmit = props.onSubmit) === null || _props$onSubmit === void 0 || _props$onSubmit.call(props);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)($f5a0b35dc85e9d3d$var$Container, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $6rqzN.ClinicLogo), {
                flavor: "default",
                isShowName: true
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)($f5a0b35dc85e9d3d$var$Form, {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $9CbxY.InputWithIcon), {
                        value: login,
                        placeholder: "\u041B\u043E\u0433\u0438\u043D",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ZkYi))),
                        handleChange: setLogin,
                        error: !!isError
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $9CbxY.InputWithIcon), {
                        value: password,
                        placeholder: "\u041F\u0430\u0440\u043E\u043B\u044C",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jEiCU))),
                        handleChange: setPassword,
                        type: "password",
                        error: isError && "\u0412\u0432\u0435\u0434\u0435\u043D \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u0439 \u043B\u043E\u0433\u0438\u043D \u0438\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C" || false
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $5koK7.PrimaryButton), {
                        primaryButtonContainer: $f5a0b35dc85e9d3d$var$ButtonContainer,
                        type: "submit",
                        children: "\u0412\u043E\u0439\u0442\u0438"
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("5koK7", function(module, exports) {

$parcel$export(module.exports, "PrimaryButtonContainer", function () { return $3e1203728585f0f5$export$bd1c103ba02b2179; });
$parcel$export(module.exports, "PrimaryButtonText", function () { return $3e1203728585f0f5$export$fdca47f788ab6569; });
$parcel$export(module.exports, "PrimaryButton", function () { return $3e1203728585f0f5$export$ac16a6a04d9b7c84; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $jCoLF = parcelRequire("jCoLF");

var $hxwKM = parcelRequire("hxwKM");

var $i0wFy = parcelRequire("i0wFy");

var $6dHL0 = parcelRequire("6dHL0");
const $3e1203728585f0f5$export$bd1c103ba02b2179 = (0, $jCoLF.default)((0, $hxwKM.Container)).withConfig({
    displayName: "PrimaryButton__PrimaryButtonContainer",
    componentId: "sc-1emrpfb-0"
})([
    "width:256px;height:60px;background:",
    ";&:hover{background:",
    ";box-shadow:0 3px 5px 0 ",
    ";}"
], (props)=>props.disabled ? (0, $i0wFy.colors).gray200 : (0, $i0wFy.colors).magenta, (0, $i0wFy.colors).lightMagenta, (0, $6dHL0.rgba)((0, $i0wFy.colors).magenta, 0.25));
const $3e1203728585f0f5$export$fdca47f788ab6569 = (0, $jCoLF.default).span.withConfig({
    displayName: "PrimaryButton__PrimaryButtonText",
    componentId: "sc-1emrpfb-1"
})([
    "font-size:16px;font-weight:500;letter-spacing:0.4px;text-transform:uppercase;color:",
    ";"
], (props)=>props.disabled && (0, $i0wFy.colors).black || (0, $i0wFy.colors).white);
const $3e1203728585f0f5$export$ac16a6a04d9b7c84 = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $hxwKM.DefaultButton), {
        ...props,
        overrides: {
            Container: {
                component: props.primaryButtonContainer || $3e1203728585f0f5$export$bd1c103ba02b2179
            },
            Text: {
                component: props.primaryButtonText || $3e1203728585f0f5$export$fdca47f788ab6569,
                props: {
                    disabled: props.disabled
                }
            }
        }
    });

});
parcelRegister("hxwKM", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $cc4eece6eab93b75$export$42a852a2b6b56249; });
$parcel$export(module.exports, "DefaultButton", function () { return $cc4eece6eab93b75$export$b7c3a2f69225ecf; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $jCoLF = parcelRequire("jCoLF");

var $6dHL0 = parcelRequire("6dHL0");

var $i0wFy = parcelRequire("i0wFy");

var $6m3m5 = parcelRequire("6m3m5");

var $cYFxl = parcelRequire("cYFxl");
const $cc4eece6eab93b75$export$42a852a2b6b56249 = (0, $jCoLF.default).button.withConfig({
    displayName: "DefaultButton__Container",
    componentId: "sc-c6zriv-0"
})([
    "height:44px;padding:0 15px;box-sizing:border-box;position:relative;border:solid 1px ",
    ";border-radius:4px;background:transparent;display:flex;align-items:center;justify-content:center;text-decoration:none;font-family:inherit;cursor:pointer;transition:all 0.15s ease-in-out;",
    ""
], (0, $6dHL0.rgba)((0, $i0wFy.colors).black, 0.1), (props)=>!props.disabled && `
             &:hover {
                border-color: ${(0, $i0wFy.colors).magenta};
             }
       ` || `
            opacity: 0.5;
            filter: grayscale(1);
            pointer-events: none;
       `);
const $cc4eece6eab93b75$var$ButtonCapsUppercaseLeft = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $6m3m5.ButtonCaps), {
        ...props,
        modifiers: [
            "uppercase",
            "left"
        ]
    });
const $cc4eece6eab93b75$var$Text = (0, $jCoLF.default)($cc4eece6eab93b75$var$ButtonCapsUppercaseLeft).withConfig({
    displayName: "DefaultButton__Text",
    componentId: "sc-c6zriv-1"
})([
    "transition:color 0.15s ease-in-out;",
    ":hover &{color:",
    ";}"
], $cc4eece6eab93b75$export$42a852a2b6b56249, (0, $i0wFy.colors).magenta);
const $cc4eece6eab93b75$var$TextContainer = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("div", {
        children: props.children
    });
const $cc4eece6eab93b75$var$Icon = ()=>null;
const $cc4eece6eab93b75$var$IconContainer = ()=>null;
const $cc4eece6eab93b75$var$OverridableProps = {
    Container: $cc4eece6eab93b75$export$42a852a2b6b56249,
    Text: $cc4eece6eab93b75$var$Text,
    TextContainer: $cc4eece6eab93b75$var$TextContainer,
    Icon: $cc4eece6eab93b75$var$Icon,
    IconContainer: $cc4eece6eab93b75$var$IconContainer
};
const $cc4eece6eab93b75$export$b7c3a2f69225ecf = (props)=>{
    const overridableProps = typeof props !== "undefined" ? props : undefined && typeof undefined.props !== "undefined" ? undefined.props : arguments[0];
    const overridableComponents = {
        Container: typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.Container && overridableProps.overrides.Container.component || $cc4eece6eab93b75$export$42a852a2b6b56249,
        IconContainer: typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.IconContainer && overridableProps.overrides.IconContainer.component || $cc4eece6eab93b75$var$IconContainer,
        Icon: typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.Icon && overridableProps.overrides.Icon.component || $cc4eece6eab93b75$var$Icon,
        TextContainer: typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.TextContainer && overridableProps.overrides.TextContainer.component || $cc4eece6eab93b75$var$TextContainer,
        Text: typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.Text && overridableProps.overrides.Text.component || $cc4eece6eab93b75$var$Text
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)(overridableComponents.Container, {
        type: props.type ? props.type : "button",
        ...typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.Container && overridableProps.overrides.Container.props || {},
        disabled: props.disabled || props.isLoading,
        onClick: props.onClick,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)(overridableComponents.IconContainer, {
                ...typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.IconContainer && overridableProps.overrides.IconContainer.props || {},
                children: /*#__PURE__*/ (0, $ih19M.jsx)(overridableComponents.Icon, {
                    ...typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.Icon && overridableProps.overrides.Icon.props || {}
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)(overridableComponents.TextContainer, {
                ...typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.TextContainer && overridableProps.overrides.TextContainer.props || {},
                children: /*#__PURE__*/ (0, $ih19M.jsx)(overridableComponents.Text, {
                    ...typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.Text && overridableProps.overrides.Text.props || {},
                    children: props.children
                })
            }),
            props.isLoading && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cYFxl.AbsoluteLoader), {})
        ]
    });
};

});


parcelRegister("9CbxY", function(module, exports) {

$parcel$export(module.exports, "InputWithIconContainer", function () { return $70009ead6ef8ab90$export$980a155dec2caaeb; });
$parcel$export(module.exports, "InputWithIcon", function () { return $70009ead6ef8ab90$export$1d04a355e3a12077; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $jCoLF = parcelRequire("jCoLF");

var $i0wFy = parcelRequire("i0wFy");

var $4eN8l = parcelRequire("4eN8l");

var $gIrEG = parcelRequire("gIrEG");
const $70009ead6ef8ab90$var$StyledInput = (0, $jCoLF.default)((0, $gIrEG.BaseStyledInput)).withConfig({
    displayName: "InputWithIcon__StyledInput",
    componentId: "sc-n8o65t-0"
})([
    "padding-top:18px;padding-bottom:18px;padding-left:51px;::placeholder{opacity:1;color:",
    ";}"
], (0, $i0wFy.colors).darkBlack);
const $70009ead6ef8ab90$export$980a155dec2caaeb = (0, $jCoLF.default).div.withConfig({
    displayName: "InputWithIcon__InputWithIconContainer",
    componentId: "sc-n8o65t-1"
})([
    "position:relative;width:100%;"
]);
const $70009ead6ef8ab90$var$Icon = (0, $jCoLF.default).div.withConfig({
    displayName: "InputWithIcon__Icon",
    componentId: "sc-n8o65t-2"
})([
    "width:26px;height:26px;background:url(",
    ") no-repeat;background-size:contain;position:absolute;top:16px;left:13px;"
], (props)=>props.icon);
const $70009ead6ef8ab90$export$1d04a355e3a12077 = (props)=>{
    const { icon: icon, ...defaultIconProps } = props;
    const IconComponent = ()=>/*#__PURE__*/ (0, $ih19M.jsx)($70009ead6ef8ab90$var$Icon, {
            icon: icon
        });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $4eN8l.DefaultInput), {
        ...defaultIconProps,
        overrides: {
            Container: {
                component: $70009ead6ef8ab90$export$980a155dec2caaeb
            },
            Icon: {
                component: IconComponent
            },
            Input: {
                component: $70009ead6ef8ab90$var$StyledInput
            }
        }
    });
};

});

parcelRegister("2ZkYi", function(module, exports) {
module.exports = new URL("user.9cd3f34e.svg", import.meta.url).toString();

});

parcelRegister("jEiCU", function(module, exports) {
module.exports = new URL("lock.143fbe09.svg", import.meta.url).toString();

});

parcelRegister("iSaFr", function(module, exports) {

$parcel$export(module.exports, "RoundedRectangleWithShadow", function () { return $dbd58b70f1a31d67$export$12ce6bf569d9a2e9; });

var $jCoLF = parcelRequire("jCoLF");

var $i0wFy = parcelRequire("i0wFy");
const $dbd58b70f1a31d67$export$12ce6bf569d9a2e9 = (0, $jCoLF.default).div.withConfig({
    displayName: "RoundedRectangleWithShadow",
    componentId: "sc-c6mdke-0"
})([
    "border-radius:3px;box-shadow:0 7px 9px 0 rgba(0,0,0,0.03);background-color:",
    ";"
], (0, $i0wFy.colors).white);

});

parcelRegister("6rqzN", function(module, exports) {

$parcel$export(module.exports, "ClinicLogotype", function () { return $4b09e1311d4b241e$export$9048896c93e61f5b; });
$parcel$export(module.exports, "ClinicLogo", function () { return $4b09e1311d4b241e$export$e3f0901e22e20f30; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $jCoLF = parcelRequire("jCoLF");

var $hjHDw = parcelRequire("hjHDw");

var $c8KFw = parcelRequire("c8KFw");

var $gviKx = parcelRequire("gviKx");

var $dTuF2 = parcelRequire("dTuF2");

var $6RZTG = parcelRequire("6RZTG");

var $6sGnW = parcelRequire("6sGnW");

var $PW6XX = parcelRequire("PW6XX");
const $4b09e1311d4b241e$export$9048896c93e61f5b = (0, $jCoLF.default).img.withConfig({
    displayName: "ClinicLogo__ClinicLogotype",
    componentId: "sc-lfq14-0"
})([
    "grid-area:logo;"
]);
const $4b09e1311d4b241e$export$e3f0901e22e20f30 = ({ flavor: flavor = (0, $PW6XX.AvailableApplicationFlavors).DEFAULT, isShowName: isShowName = false, width: width = "auto", height: height = "90px" })=>{
    const image = {
        [(0, $PW6XX.AvailableApplicationFlavors).DEFAULT]: isShowName ? (0, (/*@__PURE__*/$parcel$interopDefault($hjHDw))) : (0, (/*@__PURE__*/$parcel$interopDefault($c8KFw))),
        [(0, $PW6XX.AvailableApplicationFlavors).TELEMED]: isShowName ? (0, (/*@__PURE__*/$parcel$interopDefault($hjHDw))) : (0, (/*@__PURE__*/$parcel$interopDefault($c8KFw))),
        [(0, $PW6XX.AvailableApplicationFlavors).SUNRISE]: isShowName ? (0, (/*@__PURE__*/$parcel$interopDefault($gviKx))) : (0, (/*@__PURE__*/$parcel$interopDefault($dTuF2))),
        [(0, $PW6XX.AvailableApplicationFlavors).CEG]: isShowName ? (0, (/*@__PURE__*/$parcel$interopDefault($6RZTG))) : (0, (/*@__PURE__*/$parcel$interopDefault($6sGnW)))
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)($4b09e1311d4b241e$export$9048896c93e61f5b, {
        src: image[flavor],
        width: width,
        height: height
    });
};

});
parcelRegister("hjHDw", function(module, exports) {
module.exports = new URL("fominLogoWithName.bac48417.png", import.meta.url).toString();

});

parcelRegister("c8KFw", function(module, exports) {
module.exports = new URL("fominLogoWithoutName.d0d5a8d4.png", import.meta.url).toString();

});

parcelRegister("gviKx", function(module, exports) {
module.exports = new URL("rassvetLogoWithName.fdd5ba11.png", import.meta.url).toString();

});

parcelRegister("dTuF2", function(module, exports) {
module.exports = new URL("rassvetLogoWithoutName.a3f3b4b2.png", import.meta.url).toString();

});

parcelRegister("6RZTG", function(module, exports) {
module.exports = new URL("cegLogoWithName.23444fd8.png", import.meta.url).toString();

});

parcelRegister("6sGnW", function(module, exports) {
module.exports = new URL("cegLogoWithoutName.258eab4b.png", import.meta.url).toString();

});



parcelRegister("h6oqG", function(module, exports) {

$parcel$export(module.exports, "ComponentFabric", function () { return $c735f26204e29e8a$export$6cd052671b641a01; });
parcelRequire("bh6RR");

var $PW6XX = parcelRequire("PW6XX");
const $c735f26204e29e8a$export$6cd052671b641a01 = (props)=>{
    return (0, $PW6XX.getValueByFlavor)(props.flavors);
};

});

parcelRegister("3ta5H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $286be861e9c9909f$export$2e2bcd8739ae039; });

var $dYmtL = parcelRequire("dYmtL");
var $286be861e9c9909f$export$2e2bcd8739ae039 = {
    Auth: $dYmtL.Auth
};

});
parcelRegister("dYmtL", function(module, exports) {

$parcel$export(module.exports, "Auth", function () { return $a2c250d2d74b23f5$export$334c29725a78c21d; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $jCoLF = parcelRequire("jCoLF");

var $6rqzN = parcelRequire("6rqzN");

var $iSaFr = parcelRequire("iSaFr");

var $7twfH = parcelRequire("7twfH");
const $a2c250d2d74b23f5$var$Container = (0, $jCoLF.default)((0, $iSaFr.RoundedRectangleWithShadow)).withConfig({
    displayName: "Auth__Container",
    componentId: "sc-1zhr0k-0"
})([
    "width:610px;padding:63px 0 101px;display:flex;flex-direction:column;align-items:center;gap:16px;@media screen and (max-width:768px){width:calc(100% - 24px);box-sizing:border-box;}"
]);
const $a2c250d2d74b23f5$export$334c29725a78c21d = ()=>{
    return /*#__PURE__*/ (0, $ih19M.jsxs)($a2c250d2d74b23f5$var$Container, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $6rqzN.ClinicLogo), {
                isShowName: true
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7twfH.AuthForm), {})
        ]
    });
};

});
parcelRegister("7twfH", function(module, exports) {

$parcel$export(module.exports, "AuthForm", function () { return $571442780a9a2a10$export$c17ac1167fee36b4; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $jCoLF = parcelRequire("jCoLF");

var $hUmGa = parcelRequire("hUmGa");

var $9u3AX = parcelRequire("9u3AX");

var $kow8D = parcelRequire("kow8D");

var $aU5Wn = parcelRequire("aU5Wn");

var $5koK7 = parcelRequire("5koK7");

var $hxwKM = parcelRequire("hxwKM");

var $9CbxY = parcelRequire("9CbxY");

var $jfCsP = parcelRequire("jfCsP");

var $i6z7r = parcelRequire("i6z7r");
const $571442780a9a2a10$var$Form = (0, $jCoLF.default).form.withConfig({
    displayName: "AuthForm__Form",
    componentId: "sc-1ddwpjg-0"
})([
    "margin-top:43px;width:398px;display:flex;flex-direction:column;align-items:center;@media screen and (max-width:768px){width:100%;box-sizing:border-box;padding:0 24px;}",
    ",",
    "{margin-bottom:13px;}",
    ":last-of-type,",
    ":last-of-type{margin-bottom:32px;}"
], (0, $9CbxY.InputWithIconContainer), (0, $aU5Wn.PhoneInputWithIconContainer), (0, $9CbxY.InputWithIconContainer), (0, $aU5Wn.PhoneInputWithIconContainer));
const $571442780a9a2a10$var$ButtonContainer = (0, $jCoLF.default)((0, $5koK7.PrimaryButtonContainer)).withConfig({
    displayName: "AuthForm__ButtonContainer",
    componentId: "sc-1ddwpjg-1"
})([
    "width:244px;margin-bottom:24px;"
]);
const $571442780a9a2a10$var$VerticalLayout = (0, $jCoLF.default).div.withConfig({
    displayName: "AuthForm__VerticalLayout",
    componentId: "sc-1ddwpjg-2"
})([
    "display:flex;flex-direction:column;align-items:center;gap:16px;margin-bottom:16px;"
]);
const $571442780a9a2a10$export$c17ac1167fee36b4 = (0, $hUmGa.observer)(()=>{
    const [phone, setPhone] = (0, $bh6RR.useState)("+7");
    const [code, setCode] = (0, $bh6RR.useState)("");
    (0, $bh6RR.useEffect)(()=>{
        (0, $i6z7r.default).cleanFieldError("phone");
    }, [
        phone
    ]);
    (0, $bh6RR.useEffect)(()=>{
        (0, $i6z7r.default).cleanFieldError("code");
    }, [
        code
    ]);
    const handleSendSMS = async (event)=>{
        event.preventDefault();
        try {
            await (0, $i6z7r.default).sendSms(phone);
        } catch (e) {
            console.error(e);
        }
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        try {
            await (0, $i6z7r.default).login(phone, code);
        } catch (e) {
            console.error(e);
        }
    };
    const phoneKeyDown = (e)=>{
        if (e.key === "Enter") handleSendSMS(e);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)($571442780a9a2a10$var$Form, {
        onSubmit: handleSubmit,
        children: !(0, $i6z7r.default).isCodeRequested ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $aU5Wn.PhoneInputWithIcon), {
                    value: phone,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9u3AX))),
                    onKeyDown: phoneKeyDown,
                    name: "phone",
                    placeholder: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
                    handleChange: setPhone,
                    error: (0, $i6z7r.default).fieldErrors.phone
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $5koK7.PrimaryButton), {
                    onClick: handleSendSMS,
                    primaryButtonContainer: $571442780a9a2a10$var$ButtonContainer,
                    type: "button",
                    children: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u0434 \u0432 SMS"
                })
            ]
        }) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $9CbxY.InputWithIcon), {
                    value: code,
                    placeholder: "\u041A\u043E\u0434 \u0438\u0437 SMS",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kow8D))),
                    handleChange: setCode,
                    type: "password",
                    autoFocus: true,
                    overrides: {
                        props: {
                            maxlength: 4
                        }
                    },
                    error: (0, $i6z7r.default).fieldErrors.code
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)($571442780a9a2a10$var$VerticalLayout, {
                    children: (0, $i6z7r.default).secondsToNextSend > 0 ? /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                        children: [
                            "\u041A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D \u043D\u0430 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 \u0432\u0430\u043C\u0438 \u043D\u043E\u043C\u0435\u0440,",
                            /*#__PURE__*/ (0, $ih19M.jsx)("br", {}),
                            "\u0432\u0440\u0435\u043C\u044F \u0434\u043E \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u0439 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0438: ",
                            (0, $jfCsP.secondsToTime)((0, $i6z7r.default).secondsToNextSend)
                        ]
                    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $hxwKM.DefaultButton), {
                        type: "button",
                        onClick: handleSendSMS,
                        disabled: !(0, $i6z7r.default).isSendButtonActive,
                        children: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E"
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $5koK7.PrimaryButton), {
                    primaryButtonContainer: $571442780a9a2a10$var$ButtonContainer,
                    type: "submit",
                    children: "\u0412\u043E\u0439\u0442\u0438"
                })
            ]
        })
    });
});

});
parcelRegister("9u3AX", function(module, exports) {
module.exports = new URL("user.9cd3f34e.svg", import.meta.url).toString();

});

parcelRegister("kow8D", function(module, exports) {
module.exports = new URL("lock.143fbe09.svg", import.meta.url).toString();

});

parcelRegister("jfCsP", function(module, exports) {

$parcel$export(module.exports, "secondsToTime", function () { return $e03d41338c3fe2cc$export$a14e8754c327dfd0; });
const $e03d41338c3fe2cc$var$padZero = (number)=>number >= 10 ? number.toString() : `0${number}`;
const $e03d41338c3fe2cc$export$a14e8754c327dfd0 = (seconds)=>{
    return `${$e03d41338c3fe2cc$var$padZero(Math.floor(seconds / 60))}:${$e03d41338c3fe2cc$var$padZero(seconds % 60)}`;
};

});






//# sourceMappingURL=LoginPage.f987ed0b.js.map
